import {useMutation, useQueryClient} from 'react-query';
import SpaceSettingApiService from '@/modules/spacesSetting/services/SpaceSettingApiService';

export const useSpace = () => {
  const queryClient = useQueryClient();
  const {mutateAsync: updateSpace} = useMutation(SpaceSettingApiService.updateSetting, {
    onSuccess: () => {
      queryClient.invalidateQueries('spacesetting').then();
    }
  });

  return {
    updateSpace
  };
};
